import { Box, Flex, Slider } from "@radix-ui/themes";
import { SpeakerLoudIcon, SpeakerOffIcon } from "@radix-ui/react-icons";
import { useCallback, useContext, useState } from "react";
import { MusicContext, MusicState } from "../App.tsx";
import { EventBus } from "../game/EventBus.ts";
import { EVENTS_NAME } from "../game/consts.ts";

function Music() {
  const [music, setMusic] = useContext(MusicContext);
  const [showVolumeSlider, setShowVolumeSlider] = useState(true);

  // Update game music state and emit event with full state
  const updateGameMusic = useCallback(
    (newMusicState: Partial<MusicState>) => {
      const updatedState = { ...music, ...newMusicState };
      setMusic(updatedState);
      EventBus.emit(EVENTS_NAME.music, updatedState);
    },
    [music, setMusic],
  );

  // Toggle mute state
  const toggleMute = useCallback(() => {
    updateGameMusic({ muted: !music.muted });
  }, [music.muted, updateGameMusic]);

  // Update volume
  const handleVolumeChange = useCallback(
    (newVolume: number) => {
      updateGameMusic({ volume: newVolume });
    },
    [updateGameMusic],
  );

  // Toggle volume slider visibility
  const toggleVolumeSlider = useCallback(() => {
    setShowVolumeSlider(!showVolumeSlider);
  }, [showVolumeSlider]);

  return (
    <Box
      className="music-control"
      style={{
        position: "fixed",
        bottom: "10px",
        left: "10px",
        backgroundColor: "black",
        padding: "10px",
        borderRadius: "30px",
        zIndex: 1000,
      }}
    >
      <Flex direction="column" gap="2">
        <Box
          style={{ cursor: "pointer" }}
          onClick={toggleMute}
          onContextMenu={(event) => {
            event.preventDefault();
            toggleVolumeSlider();
          }}
        >
          {!music.muted ? (
            <SpeakerLoudIcon width="24" height="24" />
          ) : (
            <SpeakerOffIcon width="24" height="24" />
          )}{" "}
          {showVolumeSlider && (
            <span
              style={{
                fontSize: "8px",
                width: "70px",
                display: "inline-block",
              }}
            >
              (right click to hide/show slider)
            </span>
          )}
        </Box>

        {showVolumeSlider && (
          <Box style={{ width: "100px", padding: "10px" }}>
            <Slider
              value={[music.volume]}
              min={0}
              max={1}
              step={0.01}
              onValueChange={(values) => handleVolumeChange(values[0])}
            />
          </Box>
        )}
      </Flex>
    </Box>
  );
}

export default Music;
